<div class="footer" >
    <div class="card clearfix">
        <div class="logoDiv">
            {{setLabel("poweredByLabel")}} &nbsp; <a href="http://tecfolk.com/" target="_blank"><img
                    src="assets/layout/images/tecfolk-logo-trasprantNormal.png" alt=""></a> <br>
            <style>
                .copyPasswordPopup {
                    background-color: #2f4050;
                    color: #fff;
                    padding: 0px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    margin: -25px 50px 50px -60px !important;
                    white-space: nowrap;
                    position: absolute;
                }
            </style>
            <div style="align-items: center; margin-top: 10px;">
                <a href="https://wa.me/{{formattedMobileNumber}}?text= Hello%20Rashid%20Ebad%20,%20 I’m%20 interested%20 in%20 learning%20 more%20 about%20 your%20 gym%20 management%20 software.%20 Could%20 you%20 please%20 provide%20 more%20 information%20 regarding%20 its%20 features%20 and%20 pricing?%20 Thank%20 you." target="_blank" style="text-decoration: none;">
                    <span style="color: #25D366; height: 2px; display: contents; width: 2px; font-size: 20px;"><i class="fa fa-whatsapp" aria-hidden="true"></i></span> {{mobileNumber}}
                </a>
                <span >
                      <i style="cursor: pointer;" class="fa fa-copy" (click)="copyMobileNumberToClipboard()" [title]="copyTooltipText"></i>
                      <span *ngIf="phoneCopied" class="copyPasswordPopup">{{setLabel("numberCopiedLabel") || 'Number Copied'}}</span>
                    </span>
                <p style="margin: 0 0 22px 0; ">
                    {{setLabel("email:Label")}} {{emailAddress}}
                    <span>
                        <i style="cursor: pointer;" class="fa fa-copy" (click)="copyEmailToClipboard()" [title]="emailCopyTooltipText"></i>
                        <span *ngIf="emailCopied" class="copyPasswordPopup">{{setLabel("emailCopiedLabel") || 'Email Copied'}}</span>
                    </span>
                </p>
            </div>

        </div>
        <div class="url">
            <span>
                <i class="fa fa-globe" aria-hidden="true"></i>
            </span>
            <a href="https://tecfolk.com/tecgym/"
                style="color: #3d698a;margin-left: 5px; font-size: 14px;text-decoration: underline;"
                target="_blank">{{setLabel("knowAboutTecGymLabel")}}</a>
        </div>
    </div>
</div>
